import styled from "styled-components";
import { responsive } from "../../../../../../../../styles/constants.style";

export const ChildProgramsListWrapper = styled.div`
  margin: 19px 0px 39px;

  ${responsive.MOBILE`
    margin: 16px 0px 0px;
  `}
  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }
`;
